import { AlertTriangle, Info, CheckCircle, XCircle } from 'lucide-react';
import { Modal } from './Modal';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  type?: 'warning' | 'danger' | 'info' | 'success';
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
}

export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  type = 'warning',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  isLoading = false,
}: ConfirmDialogProps) {
  const icons = {
    warning: <AlertTriangle className="w-6 h-6 text-amber-600" />,
    danger: <XCircle className="w-6 h-6 text-rose-600" />,
    info: <Info className="w-6 h-6 text-primary-600" />,
    success: <CheckCircle className="w-6 h-6 text-emerald-600" />,
  };

  const iconBg = {
    warning: 'bg-amber-50 ring-amber-100',
    danger: 'bg-rose-50 ring-rose-100',
    info: 'bg-primary-50 ring-primary-100',
    success: 'bg-emerald-50 ring-emerald-100',
  };

  const buttonColors = {
    warning: 'bg-amber-500 hover:bg-amber-600',
    danger: 'bg-rose-600 hover:bg-rose-700',
    info: 'bg-primary-600 hover:bg-primary-700',
    success: 'bg-emerald-600 hover:bg-emerald-700',
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" showClose={false}>
      <div className="text-center p-2">
        <div className="flex justify-center mb-4">
          <div className={`grid h-14 w-14 place-items-center rounded-2xl ring-1 ${iconBg[type]}`}>
            {icons[type]}
          </div>
        </div>
        <h3 className="text-lg font-bold text-slate-900 mb-1.5">{title}</h3>
        <p className="text-sm text-slate-500 mb-6">{message}</p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="h-10 px-4 border border-slate-200 rounded-xl text-sm font-semibold text-slate-700 hover:bg-slate-50 hover:border-slate-300 transition-colors disabled:opacity-50"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className={`h-10 px-4 text-sm font-semibold text-white rounded-xl shadow-sm transition-colors disabled:opacity-50 ${buttonColors[type]}`}
          >
            {isLoading ? 'Aguarde...' : confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
